import { NON_STRICT_RULES } from 'domain/shared/leave';
import { BusinessRulesListField } from 'domain/people/shared/formRules';
import { FieldProps, useFieldHelper } from 'framework/ui/field';

const CategorizedBusinessRulesListField = (props: FieldProps) => {
  const { getValue } = useFieldHelper(props);
  const { errorMap } = props;

  const violatedRules = getValue() || [];
  const uniqueViolatedRules = [...new Set(violatedRules)];

  const { strictRules, nonStrictRules } = uniqueViolatedRules.reduce(
    (acc, rule) => {
      const isNonStrict = NON_STRICT_RULES.some(lookupRule => rule.startsWith(lookupRule));

      if (isNonStrict) {
        acc.nonStrictRules.push(rule);
      } else {
        acc.strictRules.push(rule);
      }

      return acc;
    },
    { strictRules: [] as string[], nonStrictRules: [] as string[] },
  );

  return (
    <>
      {strictRules.length > 0 && [
        'The following strict rules were violated: ',
        <BusinessRulesListField value={strictRules} errorMap={errorMap} />,
      ]}
      {nonStrictRules.length > 0 && [
        'The following non strict rules were violated: ',
        <BusinessRulesListField value={nonStrictRules} errorMap={errorMap} />,
      ]}
    </>
  );
};

export default CategorizedBusinessRulesListField;
